import React, { Component, Fragment } from 'react'

import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

import { fetchAveragePrice } from 'ducks/averagePrice'
import { fetchCategories } from 'ducks/categories'
import { fetchDealerInfo } from 'ducks/dealerInfo'
import { fetchDealerSchedule } from 'ducks/dealerSchedule'
import { fetchDeclareSeo } from 'ducks/declareSeo'
import { fetchDetail } from 'ducks/detail'
import { fetchAdDetailSSR } from 'ducks/ssrAdDetail'
import { fetchPhonesDetail } from 'ducks/phonesDetail'

import { config } from 'config/config'
import { productsConfig } from 'config/config.products'

import { withCookieNotice } from '@/store/context/cookie-notice-context'

import { useTargetApi as targetApi } from '@/modern/hooks/useTargetApi'
import { cookieCategoryIsActive } from '@/modern/utils/cookies'

import Categories from '@/container/Home/components/Categories'
import ModalAdReportLimit from '@/modern/components/ModalAdReportLimit'
import ModalContainer from '@/modern/components/ModalContainer'
import ModalRequireLogin from '@/modern/components/ModalRequireLogin'
import Page from '@/modern/components/Page'
import RecommendedVehiclesNewV2 from '@/modern/components/RecommendedVehiclesNewV2'
import SealsArea from '@/modern/pages/DA/SealsArea'
import Button from 'components/Button'
import AdWarning from 'components/AdWarning'
import CardVehicleAutopayment from 'components/CardVehicle/CardVehicleAutopayment'
import CardVehicleDefault from 'components/CardVehicle/CardVehicleDefault'
import CardVehicleFeirao from 'components/CardVehicle/CardVehicleFeirao'
import CardVehicleKM from 'components/CardVehicle/CardVehicleKM'
import CardVehicleSignature from 'components/CardVehicle/CardVehicleSignature'
import DetailCarousel from 'components/DetailCarousel'
import ReportAdvert from 'components/Forms/ReportAdvert'
import SendProposal from 'components/Forms/SendProposal'
import SendProposalPlaceholder from 'components/Forms/SendProposalPlaceholder'
import SimulationSantanderLib from 'components/Forms/SimulationSantanderLib'
import Main from 'components/Main'
import PlaceHolder from 'components/PlaceHolder'
import RecommendedVehicles from 'components/RecommendedVehicles'
import Tags from 'components/Tags'
import AutopagoInfo from 'components/VehicleDetails/AutopagoInfo'
import VehicleDetailsAbout from 'components/VehicleDetails/VehicleDetailsAbout'
import VehicleDetailsBasicInformation from 'components/VehicleDetails/VehicleDetailsBasicInformation'
import VehicleDetailsCharacteristicInformation from 'components/VehicleDetails/VehicleDetailsCharacteristicInformation'
import VehicleDetailsFipe from 'components/VehicleDetails/VehicleDetailsFipe'
import VehicleDetailsItemsInformation from 'components/VehicleDetails/VehicleDetailsItemsInformation'
import VehicleDetailsPlaceholder from 'components/VehicleDetails/VehicleDetailsPlaceholder'
import VehicleDetailsSellerInformation from 'components/VehicleDetails/VehicleDetailsSellerInformation'
import WhiteBox from 'components/WhiteBox'

import createTrackingData, {
  addFormProposal,
} from '@/modern/tracking/global/helpers/createTrackingData'
import { withTracking } from '@/modern/tracking/global/hooks/useTracking'
import { DATALAYER_PAGES } from '@/modern/tracking/pages'
import {
  createUrlAd,
  createUrlIdc,
  createUrlPhotoAd,
  floatToCurrency,
  formatNumber,
  getAbTestVariation,
  getCookie,
  getDataLayerUrl,
  getItemUrl,
  getItemUrlOrigin,
  getQueryParameter,
  getSeals,
  getValueFormatted,
  onClientSide,
  sendDispatchEvent,
  setCookie,
  setFormatDate,
  setFormatDateMonthYear,
} from '@/utils/utils'

import AdOverlay from '@/components/AdOverlay'
import AdPlacement from '@/components/AdPlacement'
import CertifiedPurchaseSection from '@/modern/components/CertifiedPurchase/Section'
import {
  createInsiderTrackObject,
  insertInsiderTag,
} from '@/modern/tracking/insiderTrack'
import { insiderObjectModel } from '@/modern/tracking/insiderTrack/pages/adDetail'
import {
  addOffersValue,
  addProposalId,
  createObjectConversion,
  returnConversionObject,
} from '@/modern/tracking/pages/adDetail/createDynamicData'
import {
  createDealerObject,
  createVehicleObject,
} from '@/modern/tracking/pages/default'
import {
  getBlackFairClassName,
  getBlackFairId,
  getMegaFairId,
  isBlackFairActive,
  isMegaFairActive,
} from '@/modern/utils/fairs'
import {
  COOKIE_NOTICE_TYPES,
  COOKIES,
  FAIR,
  ID_CAMPAIGN,
  LIST_OF_LKIDS,
  ORIGIN_PAGES,
  SELLER_TYPE,
  SELLER_TYPE_ENUM,
  SELLERSHIELD,
  TEXT,
  UBER_CATEGORY,
  VEHICLE_TYPE,
} from '@/utils/constants'
import { setVehicleTargeting } from '@webmotors/media-lib-ui'
import { ModalLeadFinancingSimulation } from '@webmotors/financing-lib'
import './Detail.scss'
import AdDisabled from './disabled'
import { createDealerUrl } from 'utils/string'

const uuidv4 = require('uuid/v4')

class AdDetail extends React.Component {
  constructor(props) {
    super(props)
    const data = {
      vehicleType: this.props.match.params.buyCar
        ? VEHICLE_TYPE.car
        : VEHICLE_TYPE.bike,
      idAnuncio: this.props.match.params.id,
      brand: this.props.match.params.make,
      model: this.props.match.params.model,
      version: this.props.match.params.buyCar
        ? this.props.match.params.version
        : '',
      doors: this.props.match.params.buyCar
        ? this.props.match.params.doors
        : '',
      year: this.props.match.params.years,
      cc: this.props.match.params.buyBike
        ? this.props.match.params.version
        : '',
    }

    const { cookieNoticeContext, dispatchAnalyticsEvent } = this.props
    const { cookies } = cookieNoticeContext

    this.dispatchAnalyticsEvent = dispatchAnalyticsEvent

    this.cookiesState = {
      formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
      sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
      dataFormLeads: cookieCategoryIsActive(cookies, COOKIES.DATA_FORM_LEADS),
    }
    this.state = {
      ad: undefined,
      vehicleType: data.vehicleType,
      pageName: '/webmotors/comprar/detalhe',
      no: TEXT.NAO,
      yes: TEXT.SIM,
      listCharacteristics: undefined,
      listOptionals: undefined,
      listPrincipalInformations: undefined,
      listBasicInformations: undefined,
      seller: undefined,
      photos: undefined,
      phoneNumberSeller: undefined,
      phonesDetail: undefined,
      showButtonPhone: true,
      uniqueId: 0,
      hasValidationUniqueId: true,
      alreadyShownDA: [],
      idGuid: uuidv4(),
      dataForm: undefined,
      cardForm: undefined,
      adDisabled: false,
      placeholder: true,
      loading: false,
      openFooter: true,
      averagePrice: undefined,
      fromShielding: getItemUrl(this.props.location.search, 'bld'),
      showModalFinancing: false,
      timeShowModalFinancing: false,
      eventLoop: 0,
      showModalReport: false,
      showModal: false,
      showModalRequiredLogin: false,
      counterTime: 0,
      intervalId: null,
      showStoreCarrousel: undefined,
      isSellerShield: undefined,
      showNewRecommendations: undefined,
      originRecomendacao: getItemUrlOrigin(
        this.props.location.search,
        'orirecom'
      ),
      originLojas: getItemUrlOrigin(this.props.location.search, 'orilojas'),
      originCategory: getItemUrl(this.props.location.search, 'ct'),
      blackFeirao: false,
      blackFeiraoSeal: false,
      recommendationTimestamp: new Date()
        .toISOString()
        .replace(/T/, ' ')
        .replace(/Z/, ''),
      vehicle360View: undefined,
      showAdReportsLimit: false,
      hasRespondsFast: false,
      isDealerInfoLoading: true,
      formInteracted: false,
      modalShownThisSession: false,
      isReturnVisit: false,
    }
    if (typeof document === 'undefined') {
      this.props.dispatch(fetchDeclareSeo('AdDetail'))
      if (!this.props.detail?.fetched && !this.props.detail?.requested) {
        this.props.dispatch(fetchAdDetailSSR(data, data.vehicleType))
      }
    }

    if (
      this.props.detail?.fetched &&
      this.props.detail?.result &&
      String(this.props.detail.result.UniqueId) ===
        String(this.props.match.params.id)
    ) {
      this.state = {
        ...this.state,
        ...this.returnAdObj(),
        uniqueId: String(this.props.detail.result.UniqueId),
      }
    } else if (
      typeof document === 'undefined' &&
      this.props.detail?.requested &&
      !this.props.detail?.fetched &&
      this.props.detail?.errorStatus === 404
    ) {
      this.state = { ...this.state, adDisabled: true, placeholder: false }
    }

    if (this.props.categories?.fetched && this.props.categories?.result) {
      this.state = { ...this.state, categories: this.props.categories.result }
    }
    if (this.props.averagePrice?.fetched && this.props.averagePrice?.result) {
      this.state = {
        ...this.state,
        averagePrice: this.props.averagePrice.result,
      }
    }

    this.getVehicleDetail = this.getVehicleDetail.bind(this)
    this.getListPrincipalInformations =
      this.getListPrincipalInformations.bind(this)
    this.getSeller = this.getSeller.bind(this)
    this.getListPhotos = this.getListPhotos.bind(this)
    this.getListPhonesFormatter = this.getListPhonesFormatter.bind(this)
    this.handleSendMessage = this.handleSendMessage.bind(this)
    this.seePhone = this.seePhone.bind(this)
    this.searchVehiclesSeller = this.searchVehiclesSeller.bind(this)
    this.getObjDataLayer = this.getObjDataLayer.bind(this)
    this.handleCall = this.handleCall.bind(this)
    this.renderCardForm = this.renderCardForm.bind(this)
    this.getVehicleAveragePrice = this.getVehicleAveragePrice.bind(this)
    this.handleModalAutoPayment = this.handleModalAutoPayment.bind(this)
    this.handleModalReportAdvert = this.handleModalReportAdvert.bind(this)
    this.handleModalRequiredLogin = this.handleModalRequiredLogin.bind(this)
    this.handleOpenModalAutopayment = this.handleOpenModalAutopayment.bind(this)
    this.handleShowModalFinancing = this.handleShowModalFinancing.bind(this)
    this.handleOpenModalReportAdvert =
      this.handleOpenModalReportAdvert.bind(this)
    this.handleFaq = this.handleFaq.bind(this)
    this.closeModalFinancing = this.closeModalFinancing.bind(this)
    this.acceptedModalFinancing = this.acceptedModalFinancing.bind(this)
    this.renderModalFinancing = this.renderModalFinancing.bind(this)
    this.renderModalLeadSimulation = this.renderModalLeadSimulation.bind(this)
    this.renderModalContainer = this.renderModalContainer.bind(this)
    this.handleSendProposal = this.handleSendProposal.bind(this)
    this.handleSendFinancing = this.handleSendFinancing.bind(this)
    this.handleMoreDetailsCertifiedPurchase =
      this.handleMoreDetailsCertifiedPurchase.bind(this)
    this.handleReportCertifiedPurchase =
      this.handleReportCertifiedPurchase.bind(this)
    this.handleRespondsFastEvent = this.handleRespondsFastEvent.bind(this)
    this.handleSaveActiveBlackFair = this.handleSaveActiveBlackFair.bind(this)
    this.getModalRuleState = this.getModalRuleState.bind(this)
    this.is24hWindowValid = this.is24hWindowValid.bind(this)
    this.handleFormInteraction = this.handleFormInteraction.bind(this)
  }

  componentDidMount() {
    this.getVehicleDetail()
    this.getCategories()

    if (onClientSide()) {
      window.addEventListener('respondsFast', this.handleRespondsFastEvent)
    }
    this.setTargeting()
  }

  componentDidUpdate(prevProps, prevState) {
    const { hasBlackFair, blackFair } = this.props.fairs
    if (
      !this.state.blackFeiraoSeal &&
      this.props.detail.fetched &&
      this.props.detail.result &&
      this.props.detail.result.HotDeal &&
      this.props.detail.result.HotDeal.map(i => i.Id).includes(
        `${getBlackFairId(hasBlackFair, blackFair)}`
      )
    ) {
      this.setState({
        blackFeirao: isBlackFairActive(hasBlackFair),
        blackFeiraoSeal: true,
      })
    }

    const oldCookies = prevProps.cookieNoticeContext.cookies
    const { cookies } = this.props.cookieNoticeContext

    if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.PROPOSALS]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.PROPOSALS])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        formData: cookieCategoryIsActive(cookies, COOKIES.FORM_DATA),
        sentLeads: cookieCategoryIsActive(cookies, COOKIES.SENT_LEADS),
      }
    } else if (
      JSON.stringify(oldCookies[COOKIE_NOTICE_TYPES.MARKETING]) !==
      JSON.stringify(cookies[COOKIE_NOTICE_TYPES.MARKETING])
    ) {
      this.cookiesState = {
        ...this.cookiesState,
        dataFormLeads: cookieCategoryIsActive(cookies, COOKIES.DATA_FORM_LEADS),
      }
    }

    if (
      JSON.stringify(prevProps.cookieNoticeContext) !==
      JSON.stringify(this.props.cookieNoticeContext)
    ) {
      const { ad, photos: VehiclePhotos } = this.state
      createInsiderTrackObject({
        cookieConfig: this.props.cookieNoticeContext,
        properties: insiderObjectModel({ details: { ...ad, VehiclePhotos } }),
      })
    }

    if (this.state.uniqueId && this.state.hasValidationUniqueId) {
      if (onClientSide()) {
        const hasCompletedSimulation =
          !!window.localStorage.getItem('WmFinancingProposal') ||
          !!window.localStorage.getItem('WMLoanDataLayer')
        const visitKey = `wbDAVisited_${this.state.uniqueId}`
        const hasVisitedBefore = !!window.localStorage.getItem(visitKey)
        window.localStorage.setItem(visitKey, Date.now().toString())

        const simStartedKey = `wbSimStarted_${this.state.uniqueId}`
        const hasStartedSimulation = !!window.sessionStorage.getItem(simStartedKey)

        const updatedState = { hasValidationUniqueId: false, isReturnVisit: hasVisitedBefore }

        setTimeout(() => {
          const formEl = document.getElementById('SimulationContainer')
          if (formEl && !this._formInteractionBound) {
            formEl.addEventListener('focusin', this.handleFormInteraction)
            formEl.addEventListener('input', this.handleFormInteraction)
            this._formInteractionBound = true
          }
        }, 0)

        this.setState(updatedState)

        const { modalLeadFinancingSimulation, env } = config.abTest
        targetApi({
          mboxes: [{
            name: `${modalLeadFinancingSimulation.mboxName}-${env}`,
            keys: modalLeadFinancingSimulation.key,
          }],
          callback: () => {
            const variation = getAbTestVariation(modalLeadFinancingSimulation.key, env)
            const isNewModal = variation === 'B'
            let showModalFinancingValue = false
            const stateUpdate = {}

            const isUnfinishedCase = isNewModal && hasStartedSimulation && !hasCompletedSimulation
            const isReturnedCase = isNewModal && hasVisitedBefore && !hasStartedSimulation && !hasCompletedSimulation

            if (isUnfinishedCase) {
              showModalFinancingValue = true
            } else if (isReturnedCase) {
              showModalFinancingValue = this.is24hWindowValid()
            } else {
              const showModalFinancingDA = window.localStorage.getItem('wbShowModalFinancingDA')
              if (!showModalFinancingDA) {
                showModalFinancingValue = true
              } else if (!showModalFinancingDA.split(',').includes(this.state.uniqueId)) {
                showModalFinancingValue = true
                stateUpdate.alreadyShownDA = showModalFinancingDA.split(',')
              }
              if (isNewModal && showModalFinancingValue) {
                showModalFinancingValue = this.is24hWindowValid()
              }
            }

            this.setState({ showModalFinancing: showModalFinancingValue, ...stateUpdate })
          },
        })
      }
    }

    if (prevState.isSellerShield !== this.state.isSellerShield) {
      const shouldShowNewRecommendations = !this.state.isSellerShield
      if (prevState.showNewRecommendations !== shouldShowNewRecommendations) {
        this.setState({ showNewRecommendations: shouldShowNewRecommendations })
      }
    }
    this.handleSaveActiveBlackFair()
    this.setTargeting()
  }

  componentWillUnmount() {
    if (onClientSide()) {
      window.removeEventListener('respondsFast', this.handleRespondsFastEvent)
      if (this._formInteractionBound) {
        const formEl = document.getElementById('SimulationContainer')
        if (formEl) {
          formEl.removeEventListener('focusin', this.handleFormInteraction)
          formEl.removeEventListener('input', this.handleFormInteraction)
        }
      }
    }
  }

  handleShowModalFinancing() {
    this.setState({ showModalFinancing: false })
  }

  handleOpenModalAutopayment() {
    if (!this.state.showModal) {
      this.setState({ showModal: true }, () => {
        sendDispatchEvent('saibaMaisAutopago')
      })
    }
  }

  handleOpenModalReportAdvert() {
    const { uniqueId } = this.state
    const reportsData = JSON.parse(localStorage.getItem(config.adReports)) || {}

    if (reportsData[uniqueId] >= 2) this.setState({ showAdReportsLimit: true })
    else this.setState({ showModalReport: true })
  }

  handleFaq() {
    sendDispatchEvent('saibaMaisFaqAutopago')
  }

  handleClickScrollSimulation() {
    const element = document.getElementById('SimulationContainer')
    if (onClientSide() && element) {
      const elementPosition =
        element.getBoundingClientRect().top + window.scrollY
      const marginTop = 170

      window.scroll({
        top: elementPosition - marginTop,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  handleRespondsFastEvent(e) {
    if (onClientSide()) {
      this.setState({ hasRespondsFast: e.detail.hasRespondsFast })
    }
  }

  handleMegaFairURL() {
    window.open(`${config.urlHotDeal}/feiroes/megafeirao?lkid=1787`, '_blank')
  }

  closeModalFinancing() {
    if (onClientSide()) {
      const arrayShowPopup = this.state.alreadyShownDA
      arrayShowPopup.push(this.state.uniqueId)
      window.localStorage.setItem('wbShowModalFinancingDA', arrayShowPopup)
      window.localStorage.setItem(`wbModalLastShown_${this.state.uniqueId}`, Date.now().toString())
      this.setState({ showModalFinancing: false, timeShowModalFinancing: false, modalShownThisSession: true })
    }
  }

  acceptedModalFinancing() {
    if (onClientSide()) {
      const arrayShowPopup = this.state.alreadyShownDA
      arrayShowPopup.push(this.state.uniqueId)
      window.localStorage.setItem('wbShowModalFinancingDA', arrayShowPopup)
      window.localStorage.setItem(`wbModalLastShown_${this.state.uniqueId}`, Date.now().toString())
      sendDispatchEvent('verParcelas_modalFinanciamento')
      const variation = getAbTestVariation(config.abTest.modalLeadFinancingSimulation.key, config.abTest.env)
      const isNewModal = variation === 'B'
      if (isNewModal) {
        const ctaEventMap = {
          DEFAULT: 'clicou_simularParcelas_modalFinancimento',
          UNFINISHED: 'clicou_continuarSimulacao_modalFinancimento',
          RETURNED: 'clicou_simularParcelas_modalFinancimento-retornante',
        }
        sendDispatchEvent(ctaEventMap[this.getModalRuleState()] || ctaEventMap.DEFAULT)
      }
      this.setState({ showModalFinancing: false, timeShowModalFinancing: false })
      this.handleClickScrollSimulation()
    }
  }

  renderClose() {
    return <div className="modal--close" onClick={this.closeModal.bind(this)} />
  }

  redirectToLoginPage() {
    const { intervalId } = this.state
    this.clearIntervalCounter(intervalId)
    const urlRedirect = `${config.urlLogin}${window.location.href}`
    window.open(urlRedirect, '_self')
  }

  updateCounterTime(counter) {
    this.setState({
      counterTime: counter,
    })
  }

  counterFifteenSeconds() {
    const interval = setInterval(() => {
      const { counterTime, intervalId } = this.state
      if (counterTime < 15) {
        return this.updateCounterTime(counterTime + 1)
      }
      this.clearIntervalCounter(intervalId)
      return this.redirectToLoginPage()
    }, 1000)
    this.setState({
      intervalId: interval,
    })
    return interval
  }

  renderModalRequiredLogin() {
    const { showModalRequiredLogin, counterTime } = this.state
    return (
      <ModalContainer
        show={showModalRequiredLogin}
        onBgClick={() => this.closeModal()}
        useWhiteBox
        useClose
      >
        <ModalRequireLogin
          title="Olá, para ver o telefone é preciso estar logado!"
          description="Aguarde um momento que você será redirecionado para a página de login. Se quiser voltar ao anúncio, basta fechar esta janela. ;)"
          counter={15 - counterTime}
          backButtonAction={() => this.closeModal()}
          loginButtonAction={() => this.redirectToLoginPage()}
        />
      </ModalContainer>
    )
  }

  clearIntervalCounter(id) {
    this.setState({
      intervalId: null,
    })
    clearInterval(id)
  }

  handleModalRequiredLogin() {
    this.setState({ showModalRequiredLogin: true })
    this.counterFifteenSeconds()
  }

  handleModalReportAdvert() {
    const { vehicleType, dataForm, showModalReport } = this.state
    return (
      <div>
        <ModalContainer
          show={showModalReport}
          onBgClick={() => this.closeModal()}
        >
          <div className="modal--content modal--report-advert">
            {this.renderClose()}
            <ReportAdvert dataForm={dataForm} vehicleType={vehicleType} />
          </div>
        </ModalContainer>
      </div>
    )
  }

  handleModalAutoPayment() {
    const { showModalReport } = this.state
    return (
      <ModalContainer
        show={showModalReport}
        onBgClick={() => this.closeModal()}
      >
        <div className="modal--content modal--autopayment">
          {this.renderClose()}
          <div className="explanation-autopayment">
            <div className="explanation-autopayment__col explanation-autopayment__col--left">
              <strong className="explanation-autopayment__title">
                Transação via
              </strong>
              <div className="explanation-autopayment__info">
                <strong className="explanation-autopayment__info__title">
                  O que é o AutoPago?
                </strong>
                <p className="explanation-autopayment__info__description">
                  O AutoPago é um serviço que garante ainda mais a segurança do
                  comprador e vendedor pois fazemos:
                </p>
                <ul>
                  <li>
                    <span className="icon-bull">&bull;</span> Análise cadastral
                    do comprador e vendedor;
                  </li>
                  <li>
                    <span className="icon-bull">&bull;</span> Guardamos o seu
                    dinheiro até que a transação do veículo seja finalizada.
                  </li>
                </ul>
              </div>
              <div className="explanation-autopayment__info">
                <strong className="explanation-autopayment__info__title">
                  Quanto custa o AutoPago?
                </strong>
                <p className="explanation-autopayment__info__description">
                  É cobrada uma taxa de 0,75% do valor do veículo para a
                  realização dos serviços descritos acima.
                </p>
                <p className="explanation-autopayment__info__description">
                  <b className="explanation-autopayment__info__description__attention">
                    Atenção!{' '}
                  </b>
                  O AutoPago só aceita pagamentos à vista.
                </p>
              </div>
            </div>
            <div className="explanation-autopayment__col explanation-autopayment__col--right">
              <div className="explanation-autopayment__info">
                <strong className="explanation-autopayment__info__title">
                  O que deve ser feito antes de iniciar o AutoPago?
                </strong>
                <ul>
                  <li>
                    <span className="icon-check" /> Conversar com vendedor
                  </li>
                  <li>
                    <span className="icon-check" /> Visitar o veículo
                  </li>
                  <li>
                    <span className="icon-check" /> Ambos toparem fazer a
                    transação via AutoPago
                  </li>
                </ul>
                <p className="explanation-autopayment__info__description">
                  Agora é só pedir pro vendedor te cadastrar para iniciarem o
                  Autopago ;)
                </p>
                <p className="explanation-autopayment__info__description">
                  Ficou alguma dúvida?{' '}
                  <a
                    onClick={this.handleFaq}
                    href="https://intercom.help/autopago-webmotors"
                    target="_blank"
                  >
                    Acesse nossa FAQ
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    )
  }

  loopEvent() {
    if (this.state.eventLoop === 0) {
      this.setState({ eventLoop: 1 })
    }
  }

  is24hWindowValid() {
    if (!onClientSide()) return true
    const key = `wbModalLastShown_${this.state.uniqueId}`
    const lastShown = window.localStorage.getItem(key)
    if (!lastShown) return true
    return Date.now() - parseInt(lastShown, 10) >= 24 * 60 * 60 * 1000
  }

  getModalRuleState() {
    if (!onClientSide()) return 'DEFAULT'

    const hasCompletedSimulation =
      !!window.localStorage.getItem('WmFinancingProposal') ||
      !!window.localStorage.getItem('WMLoanDataLayer')

    const simStartedKey = `wbSimStarted_${this.state.uniqueId}`
    const hasStartedSimulation = !!window.sessionStorage.getItem(simStartedKey)

    if (hasStartedSimulation && !hasCompletedSimulation) return 'UNFINISHED'
    if (this.state.isReturnVisit && !hasStartedSimulation && !hasCompletedSimulation) return 'RETURNED'

    return 'DEFAULT'
  }

  handleFormInteraction(e) {
    if (e && !e.isTrusted) return
    if (!this.state.formInteracted) {
      this.setState({ formInteracted: true })
      if (onClientSide() && this.state.uniqueId) {
        window.sessionStorage.setItem(`wbSimStarted_${this.state.uniqueId}`, '1')
      }
    }
  }

  isFinancingFormInViewport() {
    if (!onClientSide()) return false
    const el = document.getElementById('SimulationContainer')
    if (!el) return false
    const rect = el.getBoundingClientRect()
    return rect.top < (window.innerHeight || document.documentElement.clientHeight) && rect.bottom > 0
  }

  renderModalLeadSimulation() {
    const variation = onClientSide() && getAbTestVariation(config.abTest.modalLeadFinancingSimulation.key, config.abTest.env)

    // EXPERIÊNCIA "A" NÃO RENDERIZA NENHUM MODAL
    if (variation === 'A') return null;

    // EXPERIÊNCIA "B" MODAL NOVO --- ESSE AQUI
    if (variation === 'B') {
      return (
        <ModalLeadFinancingSimulation
          isOpen={this.state.timeShowModalFinancing}
          toggle={this.acceptedModalFinancing}
          no={this.closeModalFinancing}
          yes={this.acceptedModalFinancing}
          modalRuleState={this.getModalRuleState()}
        />
      )
    }

    // EXPERIÊNCIA "C" MODAL LEGADO
    return (
      <ModalContainer
        show={this.state.timeShowModalFinancing}
        onBgClick={this.closeModalFinancing}
      >
        <div className="modal--content modal--financing">
          <div className="explanation-financing">
            <div
              className="modal--close"
              onClick={this.closeModalFinancing}
            />
            <div className="explanation-financing__info">
              <div
                className="explanation-financing__header"
                style={{ justifyContent: 'center' }}
              >
                <img
                  src="/assets/img/financiamento/cash.svg"
                  width={278}
                  height={250}
                  alt="cash icon"
                />
                <div className="explanation-financing__info__title">
                  <span> Simule seu financiamento sem compromisso! </span>
                </div>
              </div>
            </div>
            <div className="explanation-financing__footer">
              <button type="button" onClick={this.acceptedModalFinancing}>
                <span>Ver parcelas</span>
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <p
                className="explanation-financing__info__description"
                style={{ width: '100%' }}
              >
                <span>
                  É rápido e fácil: <strong>você vê na hora</strong> as
                  melhores condições pra realizar o sonho do seu veículo novo!
                </span>
              </p>
            </div>
          </div>
        </div>
      </ModalContainer>
    )
  }

  renderModalFinancing() {
    if (!this.isBlackFairAd()) {
      return this.renderModalLeadSimulation()
    }

    return (
      <ModalContainer
        show={this.state.timeShowModalFinancing}
        onBgClick={this.closeModalFinancing}
      >
        <div className="modal--content modal--financing modal--blackfair">
          <div className="explanation-financing --blackfair">
            <img
              className="--close-modal"
              role="presentation"
              onClick={this.closeModalFinancing}
              src="/assets/img/webp/blackfeirao/icon-close-black.webp"
              width={24}
              height={24}
              alt="close icon"
            />
            <div className="theme-black-logo">
              <img
                src="/assets/img/blackfeirao/Black2025 - Logo 3D - Horizontal 1.png"
                alt="logo black feirão"
                width={300}
                height={92}
              />
            </div>
            <div className="explanation-financing__info">
              <div
                className="explanation-financing__header"
                style={{ justifyContent: 'center' }}
              >
                <div className="explanation-financing__info__title">
                  <p>
                    <strong>
                      <span
                        style={{
                          fontSize: '27px',
                          fontWeight: '900',
                          lineHeight: '36px',
                          textTransform: 'uppercase',
                        }}
                      >
                        falta pouco pra
                      </span>
                      <br />
                      <span
                        style={{
                          fontSize: '44px',
                          textTransform: 'uppercase',
                          lineHeight: '36px',
                          fontWeight: '900',
                          color: '#E22446',
                          fontStyle: 'italic',
                        }}
                      >
                        chamar de seu
                      </span>
                    </strong>
                    <span
                      style={{
                        color: '#333',
                        fontSize: '18px',
                        fontWeight: '400',
                        textAlign: 'center',
                        lineHeight: '20px',
                      }}
                    >
                      Financie{' '}
                      <strong
                        style={{
                          fontSize: '18px',
                          fontWeight: '900',
                          textTransform: 'uppercase',
                          textDecoration: 'italic',
                        }}
                      >
                        em até 60x
                      </strong>{' '}
                      e realize seu sonho
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div className="explanation-financing__footer">
              <button type="button" onClick={this.acceptedModalFinancing}>
                <span>Ver parcelas</span>
              </button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <p
                className="explanation-financing__info__description"
                style={{ width: '100%' }}
              >
                <span>
                  Condições válidas até 30/11/2025. Crédito sujeito a análise
                  e <br />
                  condições vigentes no momento da contratação. Taxa especial
                  para <br />
                  financiamento exclusivo com o Santander financiamentos.
                  Consulte <br />
                  condições em webmotors.com.br/solutions/feirao
                </span>
              </p>
            </div>
          </div>
        </div>
      </ModalContainer>
    )
  }

  renderModalMegaFair() {
    return (
      <ModalContainer
        show={this.state.timeShowModalFinancing}
        onBgClick={this.closeModalFinancing}
      >
        <div className="modal--content modal--financing modal--megafair">
          <div className="explanation-financing --megafair">
            <div className="header--mega">
              <img
                className="--close-modal"
                role="presentation"
                onClick={this.closeModalFinancing}
                src="/assets/img/icon/icon-closed-black.svg"
                alt="close icon"
              />
              <div className="theme-mega-logo">
                <img
                  src="/assets/img/megafeirao/MegaFeirao-title-2026.svg"
                  alt="Logo Mega Feirao"
                />
              </div>
            </div>
            <div className="body--mega">
              <div className="explanation-financing__info">
                <div className="explanation-financing__header">
                  <div className="explanation-financing__info__title">
                    <p className='first-line'>
                      FALTAM POUCOS TOQUES<br />
                    </p>
                    <p>
                      <em>
                        PRA SUA CONQUISTA
                      </em>
                    </p>
                    <p>
                      <span>
                        Financie{' '}
                        <strong>
                          EM ATÉ 60X
                        </strong>{' '}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="explanation-financing__footer">
                <button type="button" onClick={this.acceptedModalFinancing}>
                  <span>Simular financiamento</span>
                </button>
                <small>
                  Taxas a partir de 1,19% a.m. para carros e 1,34% a.m. para motos,
                  mediante aprovação de crédito pelo Santander Financiamentos.
                  Exemplo meramente ilustrativo. Condições válidas durante o Mega Feirão Webmotors
                  (de 07/07/2026 até 10/08/2026).
                  Possibilidade de carência de até 90 dias para pagamento da primeira parcela.
                  Consulte condições completas no site.
                </small>
              </div>
            </div>
          </div>
        </div>
      </ModalContainer>
    )
  }

  renderModalContainer() {
    const { eventLoop } = this.state
    const variation = onClientSide() && getAbTestVariation(config.abTest.modalLeadFinancingSimulation.key, config.abTest.env)
    const isNewModal = variation === 'B'
    let justOneEvent = true

    if (onClientSide()) {
      if (eventLoop < 1) {
        const openModal = () => {
          if (isNewModal) {
            if (
              this.state.formInteracted ||
              this.state.modalShownThisSession ||
              this.isFinancingFormInViewport()
            ) return
          }
          this.setState({ timeShowModalFinancing: true })
          if (justOneEvent) {
            sendDispatchEvent('modalFinanciamento_detalheAnuncio_impressao')
            if (isNewModal) {
              const impressionEventMap = {
                DEFAULT: 'exibiu_simularParcelas_modalFinancimento',
                UNFINISHED: 'exibiu_continuarSimulacao_modalFinancimento',
                RETURNED: 'exibiu_simularParcelas_modalFinancimento_retornante',
              }
              sendDispatchEvent(impressionEventMap[this.getModalRuleState()] || impressionEventMap.DEFAULT)
            }
            justOneEvent = false
          }
        }
        if (isNewModal) {
          setTimeout(openModal, 15000)
        } else {
          document.addEventListener('mouseleave', openModal)
          setTimeout(() => {
            openModal()
            document.removeEventListener('mouseleave', openModal)
          }, 15000)
        }
      }
      this.loopEvent()
    }

    return this.isMegaFairAd()
      ? this.renderModalMegaFair()
      : this.renderModalFinancing()
  }

  getVehicleDetail() {
    if (
      this.props.detail.fetched &&
      this.props.detail.result &&
      this.props.detail.result.UniqueId == this.props.match.params.id
    ) {
      this.setAdState()
      this.setState({ uniqueId: this.props.detail.result.UniqueId.toString() })
    } else {
      this.getDetail()
    }
  }

  getDetail() {
    const data = {
      vehicleType: this.state.vehicleType,
      idAnuncio: this.props.match.params.id,
      brand: this.props.match.params.make,
      model: this.props.match.params.model,
      version:
        this.state.vehicleType == 'car' ? this.props.match.params.version : '',
      doors:
        this.state.vehicleType == 'car' ? this.props.match.params.doors : '',
      year: this.props.match.params.years,
      cc:
        this.state.vehicleType == 'bike' ? this.props.match.params.version : '',
    }

    if (!this.props.detail.fetched) {
      this.props.dispatch(fetchDetail(data)).then(() => {
        if (this.props.detail.fetched && this.props.detail.result) {
          this.setState({
            uniqueId: this.props.detail.result.UniqueId.toString(),
          })
          return this.setAdState()
        }
        return this.setState({ adDisabled: true })
      })
    }
  }

  getCategories() {
    if (!this.props.categories.fetched) {
      this.props.dispatch(fetchCategories()).then(() => {
        if (this.props.categories.fetched && this.props.categories.result)
          this.setState({ categories: this.props.categories.result })
      })
    } else {
      this.setState({ categories: this.props.categories.result })
    }
  }

  returnAdObj() {
    return {
      ad: this.props.detail.result,
      listBasicInformations: AdDetail.getListBasicInformations(
        this.props.detail.result
      ),
      listPrincipalInformations: this.getListPrincipalInformations(
        this.props.detail.result
      ),
      listCharacteristics: AdDetail.getListCharacteristics(
        this.props.detail.result.Specification
      ),
      listOptionals: AdDetail.getListOptionals(
        this.props.detail.result.Specification.Optionals
      ),
      seller: this.getSeller(this.props.detail.result),
      photos: this.getListPhotos(
        this.props.detail.result.Media ? this.props.detail.result : undefined
      ),
      placeholder: false,
      vehicle360View:
        this.props.detail.result &&
        this.props.detail.result.IsElegible360View &&
        this.props.detail.result.Vehicle360View,
    }
  }

  setAdState() {
    this.setState(this.returnAdObj(), () => {
      if (typeof document !== 'undefined') {
        this.setState(this.setPropertiesSeo())
      }

      if (this.state.seller.SellerType !== 'PF') {
        this.setState({ isDealerInfoLoading: true })
        this.props
          .dispatch(fetchDealerInfo(this.state.seller.SellerId))
          .then(() => {
            const dealerInfo = this.props.dealerInfo.result
            let isSellerShield = false
            let showStoreCarrousel = false

            if (dealerInfo && dealerInfo.shield) {
              if (
                dealerInfo.shield.includes(SELLERSHIELD.M) ||
                dealerInfo.shield.includes(SELLERSHIELD.G)
              ) {
                isSellerShield = true
                showStoreCarrousel = true
              } else if (dealerInfo.shield.includes(SELLERSHIELD.P)) {
                isSellerShield = true
              }
            }

            if (
              this.state.isSellerShield !== isSellerShield ||
              this.state.showStoreCarrousel !== showStoreCarrousel
            ) {
              this.setState({
                isSellerShield,
                showStoreCarrousel,
              })
            }

            this.props
              .dispatch(fetchDealerSchedule(this.state.seller.SellerId))
              .then(() => {
                this.dispatchOthers()
              })
          })
          .finally(() => {
            this.setState({ isDealerInfoLoading: false })
          })
      } else {
        this.setState({ showStoreCarrousel: false }, () => {
          this.dispatchOthers()
        })
      }
    })
  }

  dispatchOthers() {
    this.getVehicleAveragePrice()
    this.renderCardForm()
  }

  setPropertiesSeo() {
    const _data = this.state.ad || {}
    const _paramQuery = getDataLayerUrl(this.props.location)

    const _breadCrumb = this.state.ad ? this.state.ad.SEO.BreadCrumb : ''
    const _canonical = this.state.ad
      ? createUrlAd(this.state.ad, this.state.vehicleType)
      : ''

    let _price = ''
    if (config.signatureIds.includes(_data.Seller.Id))
      _price = `R$ ${_data.LongComment}`
    else _price = `R$ ${formatNumber(_data.Prices.Price)}`

    const _canal = _paramQuery.hd
      ? decodeURIComponent(_paramQuery.hd)
      : config.system
    const _title = `${_data.Specification.Title} - ${_canal} - ${_data.UniqueId}`
    const _ogTitle = `Confira oferta: ${_data.Specification.Make.Value} ${_data.Specification.Model.Value} na Webmotors, compre sem dor de cabeça ;)`
    const _description = `${_title} ${_data.Specification.YearFabrication}/${_data.Specification.YearModel} por ${_price}. Entre e confira as facilidades para comprar na ${_canal}!`
    const _ogDescription = `${_data.Specification.Title} ${_data.Specification.YearFabrication}/${_data.Specification.YearModel}. Confira no site! www.webmotors.com.br`

    const _seo = {
      title: _title,
      ogTitle: _ogTitle,
      description: _description,
      ogDescription: _ogDescription,
      image: this.state.photos[0],
      breadCrumb: _breadCrumb,
      canonical: _canonical,
    }
    return _seo
  }

  getObjDataLayer(dispatch = true) {
    const { hasMegaFair, megaFair, hasBlackFair, blackFair } = this.props.fairs
    const { vehicle360View } = this.state
    const dataLayerBestSeller = []
    const dataLayerCategories = []
    const dataLayerProductsConfig = []
    const leadsIdsArr =
      this.cookiesState.sentLeads && getCookie(COOKIES.SENT_LEADS)
    let _positionCategory
    let _nameCategory

    if (
      this &&
      this.props.recommendedVehicles &&
      this.props.recommendedVehicles.fetched &&
      this.props.recommendedVehicles.result
    ) {
      let array = this.props.recommendedVehicles.result.SearchResults.slice()
      if (leadsIdsArr) {
        array = array.filter(
          item => !leadsIdsArr.split(',').includes(`${item.UniqueId}`)
        )
      }
    }

    if (productsConfig) {
      productsConfig.map((value, key) => {
        dataLayerProductsConfig.push(`${key}:${value.Nome}`)
      })
    }

    if (
      this &&
      this.props.bestSellers &&
      this.props.bestSellers.fetched &&
      this.props.bestSellers.result
    ) {
      this.props.bestSellers.result.map((value, key) => {
        dataLayerBestSeller.push(
          `${key}:${value.make} ${value.model}${
            value.anode ? ` ${value.anode}` : ''
          }`
        )
      })
    }

    if (this.state.categories) {
      this.state.categories.map((item, key) => {
        if (item.Categoria == this.state.originCategory) {
          _positionCategory = key
          _nameCategory = item.Nome
        }
        dataLayerCategories.push(`${key}:${item.Categoria}`)
      })
    }

    let valuesFeirao = []

    if (this.state.ad.HotDeal) {
      valuesFeirao = this.state.ad.HotDeal.filter(
        ({ Id }) => +Id === FAIR.megaFair.id
      )
    }

    const { search, href } = onClientSide() ? window.location : {}

    const { detail, dealerInfo, userIsAuth, averagePrice } = this.props
    const { ad, photos: VehiclePhotos = [], vehicleType, idGuid } = this.state

    const { Seller, CreatedDate: CreateDateDetail } = detail.result
    const { IsElegibleVehicleInspection } = ad

    const hasRespondsFast = this.state.hasRespondsFast

    const seals = getSeals(
      ad,
      hasMegaFair,
      megaFair,
      IsElegibleVehicleInspection,
      hasBlackFair,
      blackFair,
      hasRespondsFast
    )

    const VIEW_360 = 'View360'
    const configSpinType = [
      {
        base: ['embed.'],
        type: 'foto',
      },
      {
        base: ['cdn.', 'spins.'],
        type: 'video',
      },
    ]

    const spinType = configSpinType.find(itemConfig => {
      if (!vehicle360View) return false

      return itemConfig.base.some(base => vehicle360View.Url360.includes(base))
    })

    if (spinType) {
      seals.forEach((item, idx) => {
        if (item === VIEW_360) {
          seals[idx] = `View360-${spinType.type}`
        }
      })
    }

    let bankName

    if (detail && detail.result.Seller) {
      bankName = detail.result.Seller.HyundaiGroup ? 'hyundai' : 'santander'
    }

    const customObjDataLayer = {
      site: {
        brandOrigin: getQueryParameter(search, 'origem') || 'webmotors',
      },
      page: {
        url: href,
        trackingCode: {
          idcmp: getQueryParameter(search, 'idcmp'),
          idcmpint: getQueryParameter(search, 'idcmpint'),
          icid: getQueryParameter(search, 'icid'),
          lkid: getQueryParameter(search, 'lkid'),
        },
      },
      user: {
        loginStatus: userIsAuth ? 1 : 2,
      },
      ad: {
        guid: idGuid,
        id: ad.UniqueId,
        exposure: {
          id: undefined,
          name: undefined,
        },
        position: undefined,
        date: CreateDateDetail,
        seal: {
          id: undefined,
          name: seals.length ? seals : undefined,
        },
        pictures: {
          number: VehiclePhotos.length,
        },
      },
      dealer: createDealerObject(detail, dealerInfo),
      vehicle: createVehicleObject(detail?.result, {
        vehicleType,
        averagePrice: averagePrice?.result,
      }),
      financial: {
        bankName,
      },
    }

    if (!dispatch) {
      return customObjDataLayer
    }

    const trackingData = createTrackingData(
      'customPageView',
      DATALAYER_PAGES.adDetail,
      customObjDataLayer
    )
    this.dispatchAnalyticsEvent(trackingData)

    const trackingMegafairData = createTrackingData(
      'detalheAnuncio_primeiroAcesso',
      DATALAYER_PAGES.adDetail,
      customObjDataLayer
    )
    this.dispatchAnalyticsEvent(trackingMegafairData)

    createInsiderTrackObject({
      cookieConfig: this.props.cookieNoticeContext,
      properties: insiderObjectModel({ details: { ...ad, VehiclePhotos } }),
    })
    insertInsiderTag()
  }

  static getListBasicInformations(ad) {
    let _price = ''

    if (
      ad &&
      ad.Seller &&
      ad.Seller.Id &&
      config.signatureIds.includes(ad.Seller.Id)
    )
      _price = `R$ ${ad.LongComment}`
    else
      _price = `R$ ${
        ad && ad.Prices && ad.Prices.Price
          ? floatToCurrency(parseFloat(ad.Prices.Price), 0)
          : '0'
      }`

    const _make =
      ad && ad.Specification && ad.Specification.Make
        ? ad.Specification.Make.Value
        : ''
    const _model =
      ad && ad.Specification && ad.Specification.Model
        ? ad.Specification.Model.Value
        : ''
    const _version =
      ad && ad.Specification && ad.Specification.Version
        ? ad.Specification.Version.Value
        : ''

    const _sellerId = ad && ad.Seller && ad.Seller.Id ? ad.Seller.Id : 0

    const data = {
      title: `${_make} ${_model}`,
      make: `${_make}`,
      model: `${_model}`,
      description: _version,
      price: _price,
      SellerId: _sellerId,
    }
    return data
  }

  getListPrincipalInformations(ad) {
    const data = {
      typeCar: this.state.vehicleType === VEHICLE_TYPE.car ? true : undefined,
      year: ad.Specification.YearFabrication
        ? `${parseInt(ad.Specification.YearFabrication, 10)}/${parseInt(
            ad.Specification.YearModel,
            10
          )}`
        : undefined,
      odometer: ad.Specification.Odometer
        ? floatToCurrency(parseFloat(ad.Specification.Odometer), 0)
        : '0',
      transmission: ad.Specification.Transmission
        ? ad.Specification.Transmission
        : undefined,
      bodyType: ad.Specification.BodyType
        ? ad.Specification.BodyType
        : undefined,
      fuel: ad.Specification.Fuel ? ad.Specification.Fuel : undefined,
      // yearfuel: ad.Specification.YearFuel,
      finalPlate: ad.Specification.FinalPlate
        ? parseFloat(ad.Specification.FinalPlate)
        : undefined,
      color:
        ad.Specification.Color && ad.Specification.Color.Primary
          ? ad.Specification.Color.Secundary
            ? `${ad.Specification.Color.Primary}-${ad.Specification.Color.Secundary}`
            : ad.Specification.Color.Primary
          : undefined,
      dateCreated: ad.CreatedDate ? setFormatDate(ad.CreatedDate) : undefined,
      shift:
        ad.Specification && ad.Specification.Shift
          ? ad.Specification.Shift.Value
          : undefined,
      engine:
        ad.Specification && ad.Specification.Engine
          ? ad.Specification.Engine.Value
          : undefined,
      cooling:
        ad.Specification && ad.Specification.Cooling
          ? ad.Specification.Cooling.Value
          : undefined,
      cubicCentimeter:
        ad.Specification && ad.Specification.CubicCentimeter
          ? ad.Specification.CubicCentimeter
          : undefined,
      starter:
        ad.Specification && ad.Specification.Starter
          ? ad.Specification.Starter.Value
          : undefined,
      break:
        ad.Specification && ad.Specification.Break
          ? ad.Specification.Break.Value
          : undefined,
      charge:
        ad.Specification && ad.Specification.Charge
          ? ad.Specification.Charge.Value
          : undefined,
      location:
        ad.Seller && ad.Seller.City && ad.Seller.State
          ? `${ad.Seller.City.replace(/-/g, ' ')} - ${ad.Seller.State.substr(
              ad.Seller.State.indexOf('(') + 1,
              2
            )}`
          : undefined,
    }
    return data
  }

  static getListCharacteristics(specification) {
    const listGeneric = []

    const listLifeStyle = specification.LifeStyle || undefined
    if (listLifeStyle) {
      listLifeStyle.map(option => {
        if (
          option.Value === 'Carro de colecionador' ||
          option.Value === 'Adaptado para deficientes físicos'
        ) {
          listGeneric.push({ name: option.Value })
        }
      })
    }

    const armored = specification.Armored || undefined
    if (armored && armored === 'S') listGeneric.push({ name: 'Blindado' })

    const listCharacteristics = specification.VehicleAttributes || undefined
    if (listCharacteristics) {
      listCharacteristics.map(option => {
        listGeneric.push({ name: option.Name })
      })
    }

    const listFormatted = []
    if (listGeneric) {
      for (let index = 0; index < listGeneric.length; index++) {
        listFormatted.push({
          pos1: {
            name: listGeneric[index] ? listGeneric[index].name : undefined,
            desc: listGeneric[index] ? 'Sim' : undefined,
          },
          pos2: {
            name: listGeneric[index + 1]
              ? listGeneric[index + 1].name
              : undefined,
            desc: listGeneric[index + 1] ? 'Sim' : undefined,
          },
        })
        index++
      }
    }
    return { listFormatted, listGeneric }
  }

  static getListOptionals(optionals) {
    const listFormatted = []
    const listOptional = []

    if (optionals && optionals.length > 0) {
      for (let index = 0; index < optionals.length; index++) {
        listFormatted.push({
          pos1: optionals[index],
          pos2: optionals[index + 1],
        })
        index++
      }
      optionals.map(option => {
        listOptional.push(option.Name)
      })
    }
    return { listFormatted, listOptional }
  }

  getSeller(ad) {
    if (ad) {
      const seller = {
        TypeCar: this.state.vehicleType === VEHICLE_TYPE.car || undefined,
        UniqueId: ad.UniqueId,
        SellerId: ad.Seller.Id,
        Cnpj: ad.Seller.CNPJ,
        SellerType: ad.Seller.SellerType,
        SellerTypeName: ad.Seller.AdType ? ad.Seller.AdType.Value : undefined,
        CategoryAd: this.state.vehicleType,
        ListingType: ad.ListingType,
        Photo: ad.Seller.BannerSeller
          ? `${config.bannerPJUrl}/${ad.Seller.BannerSeller}`
          : undefined,
        UF: ad.Seller.State
          ? ad.Seller.State.substr(ad.Seller.State.indexOf('(') + 1, 2)
          : undefined,
        City: ad.Seller.City ? ad.Seller.City.replace(/-/g, ' ') : undefined,
        CreatedDate: ad.Seller.CreatedDate ? ad.Seller.CreatedDate : undefined,
        CreatedDateFormatted: ad.Seller.CreatedDate
          ? setFormatDateMonthYear(ad.Seller.CreatedDate)
          : undefined,
        AutoPagoAvailable:
          ad.Seller.SellerType &&
          ad.Seller.SellerType !== 'PJ' &&
          ad.Seller.State !== 'RJ' &&
          this.state.vehicleType === 'carro',
        Name: ad.Seller.SellerType
          ? ad.Seller.SellerType === 'PJ'
            ? ad.Seller.FantasyName
            : ad.Seller.FirstName
          : undefined,
        OpenHours:
          ad.Seller.OpenHours && ad.Seller.OpenHours.length > 0
            ? ad.Seller.OpenHours
            : undefined,
        Phone:
          ad.Seller.Phones && ad.Seller.Phones.length > 0
            ? this.getListPhonesFormatter(ad.Seller.Phones)
            : undefined,
        PhonesService: ad.Seller.PhonesServices
          ? ad.Seller.PhonesServices
          : undefined,
        searchVehiclesSeller: this.searchVehiclesSeller.bind(this),
        ShowPhone: ad.Seller.ShowPhone,
        HyundaiGroup: ad.Seller.HyundaiGroup,
      }
      return seller
    }
    return false
  }

  getListPhotos(result) {
    const photos =
      result && result.Media.Photos ? result.Media.Photos : undefined
    let listPhoto = []
    if (photos && photos.length > 0) {
      listPhoto = photos.map(photo => {
        return {
          urlBig: createUrlPhotoAd(
            photo.PhotoPath,
            this.state.vehicleType,
            this.state.ad && this.state.ad.ListingType
              ? this.state.ad.ListingType
              : undefined,
            config.photoDetailBig
          ),
          urlMedium: createUrlPhotoAd(
            photo.PhotoPath,
            this.state.vehicleType,
            this.state.ad && this.state.ad.ListingType
              ? this.state.ad.ListingType
              : undefined,
            config.photoDetailMedium
          ),
          urlSmall: createUrlPhotoAd(
            photo.PhotoPath,
            this.state.vehicleType,
            this.state.ad && this.state.ad.ListingType
              ? this.state.ad.ListingType
              : undefined,
            config.photoDetailLittle
          ),
          order: photo.Order,
          alt: `${result.Specification.Make.Value}-${result.Specification.Model.Value}-${result.Specification.YearFabrication}`,
          title: `${result.Specification.Make.Value}-${
            result.Specification.Model.Value
          }${
            VEHICLE_TYPE.car == this.state.vehicleType
              ? `-${result.Specification.Version.Value}`
              : ''
          }`,
        }
      })

      listPhoto = listPhoto.sort((a, b) => {
        if (a.order > b.order) return 1
        if (a.order < b.order) return -1
        return 0
      })
    } else {
      listPhoto.push({ url: config.noPhoto })
    }
    return listPhoto
  }

  getVehicleAveragePrice() {
    const { ad, vehicleType } = this.state
    const formattedId = getValueFormatted(ad.UniqueId)
    const { dispatch } = this.props

    dispatch(fetchAveragePrice(formattedId, vehicleType))
      .then(() => {
        const { averagePrice } = this.props
        const { result: averagePriceResult, fetched: averagePriceFetched } =
          averagePrice

        if (averagePriceFetched && averagePriceResult) {
          this.setState({ averagePrice: averagePriceResult }, () => {
            this.getObjDataLayer()
          })
        } else {
          this.getObjDataLayer()
        }
      })
      .catch(() => {
        this.getObjDataLayer()
      })
      .finally(() => {
        if (typeof window && window.location.hash === '#VerParcelasCardRB')
          this.handleClickScrollSimulation()
      })
  }

  getListPhonesFormatter(listPhones) {
    const newListPhones = listPhones.map(element => {
      const phoneNew = element.Value
      return {
        ddd: phoneNew.substring(0, 4).trim(),
        number: phoneNew.substring(4).trim(),
      }
    })
    const phone = newListPhones.length
      ? `tel:+55${
          newListPhones[0].ddd.replace('(', '').replace(')', '') +
          newListPhones[0].number
        }`
      : undefined
    this.setState({ phoneNumberSeller: phone })
    return newListPhones
  }

  closeModal() {
    this.setState({
      showModal: false,
      showModalReport: false,
      showModalRequiredLogin: false,
      counterTime: 0,
    })
    this.clearIntervalCounter(this.state.intervalId)
  }

  handleCall() {
    this.seePhone('ligar')
  }

  handleSendMessage(wantCarDelivery, isPJ) {
    const obj = {
      ...objDataLayer,
      page: {
        ...objDataLayer.page,
        pageName: '/webmotors/comprar/detalhe/envio-proposta',
      },
      conversion: { proposal: { optin: { carDelivery: '' } } },
    }

    if (isPJ)
      obj.conversion.proposal.optin.carDelivery = wantCarDelivery ? 1 : 2
    objDataLayer = obj
  }

  searchVehiclesSeller() {
    const vehicleType =
      this.state.vehicleType === VEHICLE_TYPE.car
        ? VEHICLE_TYPE.CAR
        : VEHICLE_TYPE.BIKE
    const seller = this.props?.detail?.result.Seller
    const nameSeller =
      seller?.SellerType === 'PJ' ? seller?.FantasyName : seller?.FirstName
    const uf = seller?.State
      ? seller.State.substr(seller.State.indexOf('(') + 1, 2).toLowerCase()
      : undefined
    const urlSearch =
      uf && nameSeller
        ? `${createDealerUrl(vehicleType, uf, nameSeller, seller?.Id)}?idrevendedor=${seller?.Id}`
        : `/${vehicleType}/estoque/?idrevendedor=${seller?.Id}`

    const urlFinal = createUrlIdc(
      urlSearch,
      undefined,
      'ver-estoque-vendedor',
      nameSeller ? nameSeller.replace(/ /g, '-') : undefined
    )
    return urlFinal
  }

  isRequiredLogin(sellerType) {
    const { userIsAuth } = this.props
    if (sellerType === SELLER_TYPE_ENUM.PF && !userIsAuth) {
      return true
    }
    return false
  }

  seePhone(eventDispatch) {
    this.setState({ loading: true })
    const { dispatch, phonesDetail } = this.props
    const { vehicleType, ad, loading } = this.state
    if (
      (!this.isRequiredLogin(ad.Seller.SellerType) && !loading) ||
      eventDispatch === 'ligar'
    ) {
      if (!phonesDetail.fetched) {
        const data = {
          vehicleType,
          idAnuncio: ad.UniqueId,
        }
        const { SellerType = '' } = ad.Seller || {}
        dispatch(fetchPhonesDetail(data, SellerType)).then(() => {
          const { phonesDetail } = this.props
          if (
            phonesDetail.fetched &&
            phonesDetail.result &&
            phonesDetail.requested.idAnuncio === data.idAnuncio
          ) {
            sendDispatchEvent(eventDispatch)
            const listPhones = phonesDetail.result.map(element => {
              const phoneNew = element.Phone
              return {
                ddd: phoneNew.substring(0, 4).trim(),
                number: phoneNew.substring(4).trim(),
                numberComplete: phoneNew
                  .replace('(', '')
                  .replace(')', '')
                  .replace('-', '')
                  .replace(' ', ''),
              }
            })

            if (listPhones.length > 0) {
              this.setState(
                {
                  phonesDetail: listPhones,
                  phoneNumberSeller: `tel:+55${listPhones[0].numberComplete}`,
                  showButtonPhone: eventDispatch === 'ligar',
                },
                () => {
                  if (eventDispatch === 'ligar') {
                    document.getElementById('call').click()
                    this.setState({ loading: false })
                    document
                      .querySelector('.CardSeller__phone__view ')
                      .classList.remove('CardSeller__phone__view--loading')
                  }
                }
              )
            }
          } else if (eventDispatch !== 'ligar') {
            this.setState({ loading: true })
          }
        })
      } else {
        sendDispatchEvent(eventDispatch)
        if (eventDispatch !== 'ligar') {
          this.setState({ showButtonPhone: false, loading: false })
        } else {
          document.getElementById('call').click()
          this.setState({ loading: false })
        }
      }
    } else {
      this.setState({ loading: false, showModalRequiredLogin: true })
      this.handleModalRequiredLogin()
    }
  }

  handleMoreDetailsCertifiedPurchase() {
    onClientSide() && sendDispatchEvent('maisDetalhesVistoriado')
  }

  handleReportCertifiedPurchase() {
    onClientSide() && sendDispatchEvent('visualizarLaudoVistoriado')
  }

  handleSendProposal(wantCarDelivery, isPJ, offers) {
    if (onClientSide()) {
      this.handleSendMessage(wantCarDelivery, isPJ)
      const { idGuid } = this.state
      const { financing, proposal } = returnConversionObject(objDataLayer)
      const proposalChanged = addFormProposal(proposal, 1)
      const proposalWithId = addProposalId(proposalChanged, idGuid)
      const proposalWithOffers = addOffersValue(
        proposalWithId,
        proposal.optin.carDelivery,
        offers
      )
      const conversionCreated = createObjectConversion(
        financing,
        proposalWithOffers
      )
      objDataLayer.conversion = conversionCreated
    }
  }

  handleSendFinancing() {
    if (onClientSide()) {
      const { financing, proposal } = returnConversionObject(objDataLayer)
      const proposalChanged = addFormProposal(proposal, 2)
      const conversionCreated = createObjectConversion(
        financing,
        proposalChanged
      )
      objDataLayer.conversion = conversionCreated
    }
  }

  get financingData() {
    const { ad, vehicleType, idGuid, seller } = this.state

    const { UniqueId, Prices, Specification, ListingType } = ad

    const { Make, Model, Version, YearFabrication, YearModel } = Specification

    return {
      uniqueId: UniqueId,
      listingType: ListingType,
      vehicleType,
      idGuid,
      make: Make.Value,
      makeId: Make.id,
      model: Model ? Model.Value : undefined,
      modelId: Model ? Model.Id || Model.id : undefined,
      version: Version ? Version.Value : undefined,
      versionId: Version ? Version.id : undefined,
      yearModel: parseInt(YearModel, 10),
      yearFabrication: parseInt(YearFabrication, 10),
      price: Prices.Price ? parseFloat(Prices.Price) : 0,
      storeName: seller.SellerType == 'PJ' ? seller.Name : undefined,
      storeDocument: seller.Cnpj,
      sellerId: seller.SellerId,
      sellerType: seller.SellerType,
      city: ad.Seller.City,
      sellerName: seller.SellerType == 'PF' ? seller.Name : undefined,
      hyundaiGroup: ad.Seller.HyundaiGroup,
    }
  }

  renderCardForm() {
    if (!this.state.cardForm) {
      const { ad, vehicleType, idGuid, seller } = this.state
      const {
        PhotoPath,
        UniqueId,
        Prices,
        Specification,
        ListingType,
        HotDeal,
        Seller,
        VipAutopago,
      } = ad

      const {
        Make,
        Model,
        Version,
        BodyType,
        YearFabrication,
        YearModel,
        Odometer,
      } = Specification

      const _listPhotos = []
      if (ad.Media && ad.Media.Photos && ad.Media.Photos.length >= 1) {
        ad.Media.Photos.map(_photo => {
          _listPhotos.push(
            createUrlPhotoAd(
              _photo.PhotoPath,
              this.state.vehicleType,
              ListingType
            )
          )
        })
      } else _listPhotos.push(config.noPhoto)

      const data = {
        uniqueId: UniqueId,
        listPhotos: _listPhotos,
        linkCard: undefined,
        linkThumb: PhotoPath
          ? createUrlPhotoAd(PhotoPath, this.state.vehicleType, ListingType)
          : config.noPhoto,
        title: `${Make.Value} ${Model.Value}`,
        make: Make.Value,
        model: Model.Value,
        description: Version && Version.Value ? Version.Value : BodyType,
        price: `R$ ${
          Prices.Price ? floatToCurrency(parseFloat(Prices.Price), 0) : '0'
        }`,
        year: `${parseInt(YearFabrication, 10)}/${parseInt(YearModel, 10)}`,
        km: `${Odometer ? floatToCurrency(parseFloat(Odometer), 0) : '0'} km`,
        city:
          ad.Seller.City && ad.Seller.State
            ? `${ad.Seller.City.replace(/-/g, ' ')} - ${ad.Seller.State.substr(
                ad.Seller.State.indexOf('(') + 1,
                2
              )}`
            : undefined,
      }

      const arrayCard = []
      if (config.signatureIds.includes(Seller.Id)) {
        data.price = `R$ ${ad.LongComment}`
        arrayCard.push(
          <WhiteBox
            key={`card${arrayCard.length}`}
            className="WhiteBox--card-vehicle"
          >
            <CardVehicleSignature
              id={`CardVehicleSignature_${UniqueId}`}
              data={data}
            />
          </WhiteBox>
        )
      } else if (VipAutopago) {
        arrayCard.push(
          <WhiteBox
            key={`card${arrayCard.length}`}
            className="WhiteBox--card-vehicle"
          >
            <CardVehicleAutopayment
              id={`CardVehicleAutopayment_${UniqueId}`}
              data={data}
            />
          </WhiteBox>
        )
      } else if (HotDeal) {
        arrayCard.push(
          <WhiteBox
            key={`card${arrayCard.length}`}
            className="WhiteBox--card-vehicle"
          >
            <CardVehicleFeirao
              id={`CardVehicleFeirao_${UniqueId}`}
              data={data}
            />
          </WhiteBox>
        )
      } else if (
        Seller.AdType.id === SELLER_TYPE.LOJA.ID ||
        Seller.AdType.id === SELLER_TYPE.CONCESSIONARIA.ID ||
        Seller.AdType.id === SELLER_TYPE.PESSOA_FISICA.ID
      ) {
        arrayCard.push(
          <WhiteBox
            key={`card${arrayCard.length}`}
            className="WhiteBox--card-vehicle"
          >
            <CardVehicleDefault id={`CardVehicle_${UniqueId}`} data={data} />
          </WhiteBox>
        )
      } else if (Seller.AdType.id === SELLER_TYPE.MONTADORA.ID) {
        arrayCard.push(
          <WhiteBox
            key={`card${arrayCard.length}`}
            className="WhiteBox--card-vehicle"
          >
            <CardVehicleKM id={`CardVehicleKM_${UniqueId}`} data={data} />
          </WhiteBox>
        )
      }
      this.setState(
        {
          dataForm: {
            uniqueId: UniqueId,
            listingType: ListingType,
            vehicleType,
            idGuid,
            make: Make.Value,
            makeId: Make.id,
            model: Model ? Model.Value : undefined,
            modelId: Model ? Model.Id || Model.id : undefined,
            version: Version ? Version.Value : undefined,
            versionId: Version ? Version.id : undefined,
            yearModel: parseInt(YearModel, 10),
            yearFabrication: parseInt(YearFabrication, 10),
            price: Prices.Price ? parseFloat(Prices.Price) : 0,
            storeName: seller.SellerType == 'PJ' ? seller.Name : undefined,
            storeDocument: seller.Cnpj,
            sellerId: seller.SellerId,
            sellerType: seller.SellerType,
            city: Seller.City,
            sellerName: seller.SellerType == 'PF' ? seller.Name : undefined,
            hyundaiGroup: Seller.HyundaiGroup,
          },
          cardForm: arrayCard,
        },
        () => {
          const _objDetailCookie = {
            dataForm: this.state.dataForm,
          }
          if (this.cookiesState.dataFormLeads)
            setCookie(COOKIES.DATA_FORM_LEADS, JSON.stringify(_objDetailCookie))
        }
      )
    }
  }

  isMegaFairAd() {
    const { HotDeal } = this.state.ad || {}
    const { hasMegaFair, megaFair } = this.props.fairs
    const isHotDeal = HotDeal && HotDeal.length > 0
    const isAdInMegaFair =
      isHotDeal &&
      isMegaFairActive(hasMegaFair) &&
      HotDeal.some(
        hotdeal => +hotdeal.Id === getMegaFairId(hasMegaFair, megaFair)
      )

    return isAdInMegaFair
  }

  isBlackFairAd() {
    const { HotDeal } = this.state.ad || {}
    const { hasBlackFair, blackFair } = this.props.fairs
    const isHotDeal = HotDeal && HotDeal.length > 0
    const isAdInBlackFair =
      isHotDeal &&
      isBlackFairActive(hasBlackFair) &&
      HotDeal.some(
        hotdeal => +hotdeal.Id === getBlackFairId(hasBlackFair, blackFair)
      )

    return isAdInBlackFair
  }

  handleSaveActiveBlackFair() {
    const hasBlackFairActiveKey = config.blackFairAdAIsKeyActive

    if (!onClientSide()) return
    const blackFeiraoActive = this.isBlackFairAd()
    if (blackFeiraoActive) {
      window.localStorage.setItem(hasBlackFairActiveKey, true)
    } else {
      window.localStorage.removeItem(hasBlackFairActiveKey)
    }
  }

  setTargeting() {
    const { ad, vehicleType } = this.state
    const { match } = this.props
    const vehicleDataTargeting = {
      type: vehicleType,
      brand: match.params.make,
      model: match.params.model,
      version: match.params.version,
      singleYear: match.params.years,
      price: ad?.Prices?.Price ? { start: ad?.Prices?.Price } : undefined,
    }

    if (vehicleDataTargeting && setVehicleTargeting) {
      setVehicleTargeting(vehicleDataTargeting)
    }
  }

  get shouldShowSimulation() {
    return !this.isUnavailable() && !this.state.ad.VipAutopago
  }

  renderSeal() {
    const { hasBlackFair } = this.props.fairs
    const { blackFeiraoSeal, ad } = this.state
    const { HotDeal, CertifiedVehicle } = ad || {}

    const { SealFileName, SealName } = CertifiedVehicle || {}

    const certified = {
      src: SealFileName,
      name: SealName,
    }

    const isCertified = !!CertifiedVehicle
    const isDefaultFeirao = !!(config.showTagOffer && HotDeal)
    const isMegaFeirao = this.isMegaFairAd()

    if (isCertified || isDefaultFeirao) {
      const isBlackFeiraoSeal =
        isDefaultFeirao && isBlackFairActive(hasBlackFair) && blackFeiraoSeal

      return (
        <Tags
          className={`Detail__seal ${isBlackFeiraoSeal && 'tag_blackfair'}`}
          isCertified={isCertified}
          certified={certified}
          isBlackFeirao={isBlackFeiraoSeal}
          isDefaultFeirao={isDefaultFeirao}
          isMegaFeirao={isMegaFeirao}
        />
      )
    }
    if (this.state.ad && this.state.ad.VipAutopago) {
      return (
        <strong
          id="TagVehicleFeirao"
          className="Detail__seal Detail__seal--autopayment"
        >
          Transação via
        </strong>
      )
    }
    return ''
  }

  renderVehicleInformation() {
    const { cookies } = this.props.cookieNoticeContext
    return this.state.ad && this.state.placeholder == false ? (
      <div className="InformationVehicleDetails">
        <VehicleDetailsBasicInformation
          id="VehicleBasicInformation"
          basicInformations={this.state.listBasicInformations}
          seal={this.renderSeal()}
          cardId={Number(this.props.match.params.id)}
          vehicleType={this.state.vehicleType}
          isCarDelivery={this.state.ad.Seller.CarDelivery}
          isUnavailable={this.isUnavailable()}
          IsElegibleVehicleInspection={
            this.state.ad.IsElegibleVehicleInspection
          }
          trackingHandler={this.handleMoreDetailsCertifiedPurchase}
          ad={this.state.ad}
          isBlackFeirao={this.state.blackFeiraoSeal}
          hasRespondsFast={this.state.hasRespondsFast}
          hasMegaFair={this.props.fairs.hasMegaFair}
        >
          <div className="Detail__tags" />
          <VehicleDetailsCharacteristicInformation
            className="VehicleDetails--no-shadow"
            id="VehicleCharacteristic"
            characteritics={this.state.listCharacteristics}
            principalInformations={this.state.listPrincipalInformations}
          />
          {!this.isUnavailable() && (
            <SealsArea
              advertisement={this.state.ad}
              idGuid={this.state.idGuid}
            />
          )}
          <VehicleDetailsAbout
            className="VehicleDetails--no-shadow"
            id="VehicleAboutInformation"
            vehicleType={this.state.vehicleType}
            longComment={this.state.ad.LongComment}
          />
          <Button
            className="Button--report-advert button-report"
            name="ButtonReportAdvert"
            id="ButtonReportAdvert"
            value="ButtonReportAdvert"
            type="submit"
            onClick={this.handleOpenModalReportAdvert}
          >
            Denunciar anúncio do veículo
          </Button>
        </VehicleDetailsBasicInformation>
        {this.state.ad.VipAutopago ? <AutopagoInfo /> : undefined}
        <VehicleDetailsItemsInformation
          id="VehicleItemsInformation"
          optionals={this.state.listOptionals}
        />

        <CertifiedPurchaseSection
          id="VehicleCertifiedPurchase"
          ad={this.state.ad}
          trackingHandler={this.handleReportCertifiedPurchase}
        />

        <VehicleDetailsSellerInformation
          id="VehicleSellerInformation"
          seller={this.state.seller}
          phonesDetail={this.state.phonesDetail}
          seePhone={this.seePhone}
          showButtonPhone={!this.isUnavailable() && this.state.showButtonPhone}
          dealerSchedule={
            this.props.dealerSchedule && this.props.dealerSchedule.result
              ? this.props.dealerSchedule.result
              : undefined
          }
          loading={this.state.loading}
          className="VehicleDetails--seller-information"
          ad={this.state.ad}
          vehicleType={this.state.vehicleType}
          sellerBadge={this.props.detail.result.SellerBadges}
        />
        <VehicleDetailsFipe
          className="VehicleDetails--fipe"
          id="VehicleFipe"
          averagePrice={this.state.averagePrice}
          adData={this.state.ad}
          seller={this.state.seller}
          vehicleType={this.state.vehicleType}
        />
        {this.shouldShowSimulation && onClientSide() ? (
          <SimulationSantanderLib
            photos={this.state.photos}
            dataForm={this.financingData || {}}
            isPJ={this.state.ad.Seller.SellerType === 'PJ'}
            sellerType={this.state.ad.Seller.SellerType}
            ad={this.state.ad}
            isBlackFeirao={this.state.blackFeiraoSeal}
            location={this.props.location}
            cookies={cookies}
            handleSendFinancing={this.handleSendFinancing}
          />
        ) : undefined}

        {this.state.ad && this.state.categories
          ? this.renderUberCategory()
          : undefined}
      </div>
    ) : (
      <div className="InformationVehicleDetails">
        <VehicleDetailsPlaceholder vehicleType={this.state.vehicleType} />
      </div>
    )
  }

  renderVehicleInformationSignature() {
    return this.state.ad && this.state.placeholder == false ? (
      <div className="InformationVehicleDetails">
        <VehicleDetailsBasicInformation
          id="VehicleBasicInformation"
          basicInformations={this.state.listBasicInformations}
          seal={
            this.state.ad &&
            config.signatureIds.includes(this.state.ad.Seller.Id) ? (
              <strong
                id="TagVehicleSignature"
                className="Detail__seal Detail__seal--signature"
              >
                IPVA, seguro e manutenção incluidos
              </strong>
            ) : (
              ''
            )
          }
          cardId={Number(this.props.match.params.id)}
          vehicleType={this.state.vehicleType}
          isCarDelivery={this.state.ad.Seller.CarDelivery}
        />
        <VehicleDetailsCharacteristicInformation
          id="VehicleCharacteristic"
          characteritics={this.state.listCharacteristics}
          principalInformations={this.state.listPrincipalInformations}
        />
        <VehicleDetailsItemsInformation
          id="VehicleItemsInformation"
          optionals={this.state.listOptionals}
        />
        <div className="VehicleDetails--signature" id="VehicleSignature">
          <img
            src={`/assets/img/webp/details-signature.webp?t=${config.randomUrl}`}
            alt="Assinatura"
            width={960}
            height={640}
          />
        </div>
      </div>
    ) : (
      <div className="InformationVehicleDetails">
        <VehicleDetailsPlaceholder vehicleType={this.state.vehicleType} />
      </div>
    )
  }

  renderUberCategory() {
    let _existUber
    const _arrayUber = []
    UBER_CATEGORY.map(x => {
      this.state.categories.map(y => {
        if (x.Url.toLowerCase() == y.Url.toLowerCase())
          _arrayUber.push({ Value: y.Nome })
      })
    })

    const _arrayCategory = this.state.ad.Specification.LifeStyle

    if (_arrayCategory) {
      _existUber = _arrayCategory.some(x => {
        return _arrayUber.some(y => {
          if (x.Value.toLowerCase() == y.Value.toLowerCase()) {
            return y
          }
        })
      })
    }

    return _existUber ? (
      <div className="ContainerUber">
        <a
          rel="noreferrer"
          className="ContainerUber__link"
          href={config.urlUber}
          target="_blank"
        >
          <img
            src={`/assets/img/webp/uber/card-uber.webp?t=${config.randomUrl}`}
            alt="Card uber"
            width={913}
            height={300}
          />
        </a>
      </div>
    ) : undefined
  }

  renderHelmet() {
    return (
      <Fragment>
        <Helmet>
          {this.state.title ? <title>{this.state.title}</title> : ''}
          <meta name="language" content="pt-br" />
          <meta name="robots" content="noindex, nofollow" />
          {this.state.description ? (
            <meta name="description" content={this.state.description} />
          ) : (
            ''
          )}
          <meta
            property="og:title"
            name="og:title"
            content={this.state.ogTitle ? this.state.ogTitle : this.state.title}
          />
          <meta
            property="og:description"
            name="og:description"
            content={
              this.state.ogDescription
                ? this.state.ogDescription
                : this.state.description
            }
          />
          {this.state.image ? (
            <meta
              property="og:image"
              name="og:image"
              content={this.state.image}
            />
          ) : (
            ''
          )}
          <meta property="og:url" content={this.props.location.href} />
          <link rel="canonical" href={this.state.canonical || ''} />
          <link
            rel="alternate"
            hreflang="pt-BR"
            href={this.state.canonical || ''}
          />
        </Helmet>
      </Fragment>
    )
  }

  isUnavailable() {
    const { ad } = this.state
    return ad && ad.Seller.ExceededPlan
  }

  isBikeAd() {
    const { vehicleType } = this.state
    return vehicleType === VEHICLE_TYPE.bike
  }

  renderDetailsContainer(children) {
    const defaultClass = 'Detail__container'
    return (
      <div
        className={`
          ${defaultClass}
          ${this.isBikeAd() && `${defaultClass}--bike`}
        `}
      >
        {children}
      </div>
    )
  }

  renderAdDetail() {
    const {
      ad,
      cardForm,
      dataForm,
      fromShielding,
      listBasicInformations,
      photos,
      placeholder,
      recommendationTimestamp,
      sendMessageContainer,
      showModalReport,
      showStoreCarrousel,
      vehicleType,
      vehicle360View,
      showNewRecommendations,
      isSellerShield,
      isDealerInfoLoading,
    } = this.state
    const { match } = this.props
    const isShowingPlaceholder = placeholder
    const isCar = vehicleType === VEHICLE_TYPE.car
    const isClientPF = ad && ad.Seller && ad.Seller.SellerType === 'PF'

    const shouldShowMediaDiv = !isSellerShield
    const shouldShowMedia = !isSellerShield && !isDealerInfoLoading

    return (
      <Fragment>
        {shouldShowMediaDiv && (
          <AdPlacement
            type="header"
            id="top"
            shouldDisplayMidias={shouldShowMedia}
          />
        )}
        {isShowingPlaceholder ? (
          <div className="PlaceHolder__ad-detail PlaceHolder__ad-detail--photocarousel">
            <PlaceHolder />
            <PlaceHolder />
            <PlaceHolder />
          </div>
        ) : (
          <DetailCarousel
            noCounter={false}
            noNumberCounter
            animateBorder
            photos={photos}
            spinProps={vehicle360View}
          />
        )}

        {this.renderDetailsContainer(
          <Fragment>
            <div className="Detail__container__left">
              {ad && config.signatureIds.includes(ad.Seller.Id)
                ? this.renderVehicleInformationSignature()
                : this.renderVehicleInformation()}
            </div>
            {!this.isUnavailable() && (
              <div className="Detail__container__right">
                {ad ? (
                  <SendProposal
                    dataForm={this.financingData}
                    SendOpen={sendMessageContainer}
                    cardForm={cardForm}
                    fromShielding={fromShielding}
                    basicInformations={listBasicInformations}
                    openModalAutopayment={this.handleOpenModalAutopayment}
                    openModalReportAdvert={this.handleOpenModalReportAdvert}
                    vipAutopago={ad.VipAutopago}
                    isPJ={ad.Seller.SellerType === 'PJ'}
                    handleSendProposal={this.handleSendProposal}
                    clickScrollSimulation={this.handleClickScrollSimulation}
                    ad={ad}
                    datalayer={this.getObjDataLayer(false)}
                    photos={photos}
                    showMedia={shouldShowMedia}
                  />
                ) : (
                  <SendProposalPlaceholder />
                )}
              </div>
            )}
            {ad && showModalReport && this.handleModalReportAdvert()}
            {this.renderModalRequiredLogin()}
          </Fragment>
        )}

        <span id="endScroll" />

        {showStoreCarrousel && (
          <RecommendedVehicles
            title="Recomendados para você"
            vehicleType={vehicleType}
            uniqueId={match.params.id}
            sellerID={ad.Seller.Id}
            origin={ORIGIN_PAGES.DETALHE.KEY}
            recommendationTimestamp={recommendationTimestamp}
          />
        )}

        {isCar && (showNewRecommendations || isClientPF) && (
          <RecommendedVehiclesNewV2
            title="Você também pode gostar"
            vehicleType={vehicleType}
            idAdvertise={match.params.id}
            showPlaceHolder={false}
            showMoreOffersButton={false}
            origin={ORIGIN_PAGES.DETALHE.KEY}
            lkIds={LIST_OF_LKIDS.NEW_RECOMMENDATION.DA}
            idCampaign={ID_CAMPAIGN.DA}
            eventName="clickRecomendacaoDA"
            context="adDetail"
          />
        )}
      </Fragment>
    )
  }

  renderExtraContent() {
    const { breadCrumb } = this.state

    return (
      <Fragment>
        <Categories
          id="categories-carousel"
          origin={ORIGIN_PAGES.DETALHE.KEY}
        />
      </Fragment>
    )
  }

  renderContentDA(children, outsideOverlayContent = null) {
    return (
      <Fragment>
        {this.isUnavailable() ? <AdOverlay>{children}</AdOverlay> : children}
        {outsideOverlayContent}
      </Fragment>
    )
  }

  render() {
    const {
      adDisabled,
      openFooter,
      placeholder,
      showModal,
      showModalFinancing,
      vehicleType,
    } = this.state
    const { location } = this.props
    const { blackFeiraoActive } = config
    const { hasMegaFair, hasBlackFair } = this.props.fairs
    const pageBlackFairClassName = getBlackFairClassName(hasBlackFair)

    const isShowingPlaceholder = placeholder

    if (adDisabled) {
      return <AdDisabled location={location} vehicleType={vehicleType} />
    }

    return (
      <Page openFooter={openFooter} url={location}>
        {this.renderHelmet()}
        {!isShowingPlaceholder && showModal && this.handleModalAutoPayment()}

        {showModalFinancing && this.renderModalContainer()}

        {this.isUnavailable() && (
          <Fragment>
            <AdWarning>
              <RecommendedVehicles
                title="Recomendados para você"
                vehicleType={vehicleType}
              />
            </AdWarning>
          </Fragment>
        )}

        {this.state.showAdReportsLimit && (
          <ModalAdReportLimit
            show
            handleCloseModal={() => {
              this.setState({ showAdReportsLimit: false })
            }}
          />
        )}

        <Main className={`page--a-detail ${pageBlackFairClassName}`}>
          {this.renderContentDA(
            this.renderAdDetail(),
            this.renderExtraContent()
          )}
        </Main>
      </Page>
    )
  }
}

export default withCookieNotice(
  connect(store => {
    return {
      detail: store.detailState,
      phonesDetail: store.phonesDetailState,
      dealerSchedule: store.dealerScheduleState,
      categories: store.categoriesState,
      recommendedVehicles: store.recommendedVehiclesState,
      averagePrice: store.averagePriceState,
      dealerInfo: store.dealerInfoState,
      declareSeo: store.declareSeoState,
      userIsAuth: store.userIsAuth,
      fairs: store.fairs,
    }
  })(withTracking(AdDetail))
)
